import { create } from 'zustand';
import { authService } from '../api/services';

const useAuthStore = create((set, get) => ({
  user: null,
  accessToken: localStorage.getItem('accessToken'),
  refreshToken: localStorage.getItem('refreshToken'),
  isLoading: false,
  isAuthenticated: !!localStorage.getItem('accessToken'),

  login: async (email, password) => {
    set({ isLoading: true });
    try {
      const res = await authService.login({ email, password });
      const { user, accessToken, refreshToken } = res.data.data;
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      set({ user, accessToken, refreshToken, isAuthenticated: true, isLoading: false });
      return { success: true };
    } catch (error) {
      set({ isLoading: false });
      return { success: false, message: error.response?.data?.message || 'Login failed' };
    }
  },

  logout: async () => {
    try {
      const { refreshToken } = get();
      await authService.logout(refreshToken);
    } catch {}
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    set({ user: null, accessToken: null, refreshToken: null, isAuthenticated: false });
  },

  fetchMe: async () => {
    try {
      const res = await authService.getMe();
      set({ user: res.data.data });
    } catch {
      get().logout();
    }
  },

  hasPermission: (permission) => {
    const { user } = get();
    if (!user?.role?.permissions) return false;
    return user.role.permissions.includes(permission) || user.role.permissions.includes('admin');
  },
}));

export default useAuthStore;
